<div
  [class.hidden]="!showDatePickerWrapper"
  class="date-picker-wrapper"
  [ngClass]="containerClass">
  <label
    (click)="toggleCalendarComponent($event)"
    class="date-range-label b2 text-gray-800">
    {{ label }}
    <!--    if compared is off and selection is not custom check if auto (start/end) option is selected,
            if so show auto and value of start/end date,
            if not show regular start and end date-->
    <div
      #calendarInput
      class="input-wrapper"
      [style.width]="datePickerInputWidth || null"
      [style.height]="datePickerInputHeight || null">
      <input
        type="text"
        [class]="datePickerInputStyleClass"
        readonly
        [value]="getDatePickerLabel()"
        [attr.size]="getDatePickerLabel().length || 10" />
      <i
        class="material-symbols-outlined calendar-icon text-blue-600"
        aria-hidden="true">
        calendar_today
      </i>
    </div>
  </label>
  <label
    *ngIf="compareEnabled"
    class="compare b2 text-gray-800"
    for="compareSwitchOutSide">
    Compare
    <m-switch
      id="compareSwitchOutSide"
      class="compare-switch mt-1"
      [(ngModel)]="compareToggledOn"
      (onChange)="toggleCompare($event.checked); openCalendar()"></m-switch>
  </label>
</div>
<m-modal
  [(visible)]="showCalendar"
  appendTo="body"
  [styleClass]="'date-picker-popup'"
  [showHeader]="false"
  [showFooter]="false"
  [modal]="true"
  [focusTrap]="true"
  (onHide)="cancel()"
  [transitionOptions]="'0ms'">
  <div
    #calendarPopup
    class="date-picker-popup-content"
    [ngClass]="{ 'position-static': pageCentered }">
    <div
      class="left-side"
      [ngClass]="{ compare: compareToggledOn && compareToggledOn }">
      <div class="left-side-content">
        <div class="date-picker-title">
          <span class="sh2 text-gray-1000">Date presets</span>
        </div>

        <div class="date-picker-info-bar">
          <i
            class="material-symbols-outlined icon-small text-gray-500"
            aria-hidden="true">
            info
          </i>
          <span class="c1 text-gray-800">{{ availabilityInfoText }}</span>
        </div>

        <div class="range-picker-section">
          <m-dropdown
            *ngIf="showPresetSelection"
            [options]="currentRangeOptions"
            optionLabel="label"
            width="100%"
            [(ngModel)]="selectedOption"
            class="b1 text-gray-1000 w-full"
            [autofocus]="true"
            (onChange)="
              changeDateRangeOption(asCurrentDropdownOption($event.value).name)
            ">
          </m-dropdown>
          <div *ngIf="showInputPickers" class="date-inputs-row">
            <input
              pInputText
              (change)="
                applyFromInputField(
                  asInputElement($event.target).value,
                  'startDate'
                )
              "
              (focus)="onInputFocus($event, 'startDate')"
              (blur)="onInputBlur($event, 'startDate')"
              [disabled]="disableStartDate"
              type="text"
              class="date-input"
              [(ngModel)]="startDate" />
            <span class="b1 text-gray-1000">-</span>
            <input
              pInputText
              type="text"
              (change)="
                applyFromInputField(
                  asInputElement($event.target).value,
                  'endDate'
                )
              "
              (focus)="onInputFocus($event, 'endDate')"
              (blur)="onInputBlur($event, 'endDate')"
              [disabled]="disableEndDate"
              class="date-input"
              [(ngModel)]="endDate" />
          </div>
          <div class="col-md-12 text-red" *ngIf="isOutOfDateRange">
            Maximum allowed duration is {{ allowedDuration }} days
          </div>
          <div class="bulk-mode" *ngIf="dateFilter && dateFilter.bulkModeValue">
            <label class="input-label">
              Select by
              <m-dropdown
                [options]="bulkModeOptions"
                width="100%"
                class="b1 text-gray-1000"
                optionLabel="label"
                optionValue="value"
                [(ngModel)]="selectedBulkMode"
                (onChange)="updateDateBasedOnBulkMode()"></m-dropdown>
            </label>
          </div>
        </div>

        @if (compareEnabled) {
          <div class="compare-section" [class.compare]="compareToggledOn">
            <div class="input-switch">
              <label for="compareSwitch">
                <m-switch
                  id="compareSwitch"
                  class="compare-toggle"
                  [(ngModel)]="compareToggledOn"
                  (onChange)="toggleCompare($event.checked)">
                </m-switch>
                <span class="toggle-text">Compare with</span>
              </label>
            </div>
            @if (compareToggledOn) {
              <m-dropdown
                [options]="compareRangeOptions"
                optionLabel="label"
                width="100%"
                [(ngModel)]="selectedCompareOption"
                class="b1 text-gray-1000"
                (onChange)="
                  changeCompareDateRangeOption(
                    asCompareDropdownOption($event.value).name
                  )
                ">
              </m-dropdown>
              <div class="date-inputs-row">
                <input
                  pInputText
                  type="text"
                  (change)="
                    applyFromInputField(
                      asInputElement($event.target).value,
                      'startDateCompare'
                    )
                  "
                  (focus)="onInputFocus($event, 'startDateCompare')"
                  (blur)="onInputBlur($event, 'startDateCompare')"
                  class="date-input"
                  [(ngModel)]="startCompareDate" />
                <span class="b1 text-gray-1000">-</span>
                <input
                  pInputText
                  type="text"
                  (change)="
                    applyFromInputField(
                      asInputElement($event.target).value,
                      'endDateCompare'
                    )
                  "
                  (focus)="onInputFocus($event, 'endDateCompare')"
                  (blur)="onInputBlur($event, 'endDateCompare')"
                  class="date-input"
                  [(ngModel)]="endCompareDate" />
              </div>
            }
          </div>
        }

        @if (showApplyForAll) {
          <div class="ms-3 d-flex gap-0">
            <m-checkbox
              [isChecked]="isApplyForAllChecked"
              [binary]="true"
              (onChange)="
                isApplyForAllChecked = !isApplyForAllChecked
              "></m-checkbox>
            <span>Apply to All Rows</span>
          </div>
        }
      </div>

      <div class="date-picker-footer flex gap-3 mt-auto">
        <m-button
          type="primary"
          [disabled]="isApplyButtonDisabled"
          (click)="apply()">
          Save
        </m-button>
        <m-button type="secondary" (click)="cancel()"> Cancel </m-button>
      </div>
    </div>
    <!--regular date range pick-->
    <div class="calendar-side single" *ngIf="!compareToggledOn && showCalendar">
      <drp-daterangepicker
        class="w-100"
        [calendarDisabled]="disableStartDate && disableEndDate"
        *ngIf="showCalendarComponent"
        [autoApply]="true"
        [linkedCalendars]="true"
        [bulkSelection]="
          dateFilter && dateFilter.bulkModeValue
            ? !!dateFilter.bulkModeValue
            : false
        "
        [selectionMode]="selectedBulkMode"
        [selectionSize]="1"
        [focusOnEndDate]="disableStartDate"
        (choosedDate)="selectCurrentDateFromCalendar(asDateRange($event))"
        [startDate]="selected.startDate"
        [lockStartDate]="disableStartDate"
        [lockEndDate]="disableEndDate"
        [endDate]="selected.endDate"
        [minDate]="minDate"
        [maxDate]="disableEndDate ? psuedoMaxEndDate : maxDate"
        [locale]="locale">
      </drp-daterangepicker>
    </div>
    <!--regular date range pick-->
    <!--compare pick calendars-->
    <div
      class="calendar-side multiple"
      *ngIf="compareToggledOn && showCalendar">
      <div class="d-flex flex-column gap-3 align-items-center">
        <drp-daterangepicker
          class="left-calendar"
          *ngIf="showCalendarComponent"
          [autoApply]="true"
          [linkedCalendars]="false"
          [startDate]="selected.startDate"
          (datesUpdated)="selectCurrentDateFromCalendar(asDateRange($event))"
          [endDate]="selected.endDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [locale]="locale">
        </drp-daterangepicker>
        <p class="calendar-label">Current Time Period</p>
      </div>
      <div class="separator"></div>

      <div class="d-flex flex-column gap-3 align-items-center">
        <drp-daterangepicker
          class="secondary"
          *ngIf="showCalendarComponent"
          [autoApply]="true"
          (datesUpdated)="selectCompareDateFromCalendar(asDateRange($event))"
          [startDate]="selectedCompare.startDate"
          [endDate]="selectedCompare.endDate"
          [minDate]="minDate"
          [maxDate]="selected.startDate.subtract(1, 'day')"
          [locale]="locale">
        </drp-daterangepicker>
        <p class="calendar-label">Comparison Time Period</p>
      </div>
    </div>
    <!--compare pick calendars-->
  </div>
</m-modal>
